<script>
import BaseButton from '@/js/components/common/buttons/BaseButton';

export default {
    name: 'DetailsButton',

    functional: true,

    props: {
        label: {type: String, default: null},
        hideLabel: {type: Boolean},
        isSmall: {type: Boolean},
        disabled: {type: Boolean},
    },

    render(createElement, {props, data, parent}) {
        data.props = {
            label: props.label || parent.$t('common.actions.details'),
            iconClass: 'fa fa-ellipsis-h',
            color: 'btn-light',
            isSmall: props.isSmall,
            hideLabel: props.hideLabel,
            disabled: props.disabled,
            type: 'button',
        };

        return createElement(BaseButton, data);
    },
};
</script>
